<template>
  <div>
    <el-form ref="formRef" :model="releaseForm" label-width="180px">
      <el-form-item label="输入内容：">
        <el-input type="textarea" placeholder="请输入内容" :rows="6" :maxlength="1500" v-model="releaseForm.msg" size="small" style="width:75%;"  />
      </el-form-item>
      <el-form-item label="上传图片：">
        <el-space wrap>
          <div class="img-box" v-for="(item, index) in imgArray" :key="item.id">
            <el-image style="width: 80px; height: 80px;" fit="cover" :src="item.smallImg" ><template #error><div class="el-img-error">暂无图片</div></template></el-image>
            <div class="delIcon" @click="delImg(item.id, releaseForm.id, index)"><ElIcons name="CloseBold" color="#ffffff"/></div>
          </div>
          <div class="add" @click="fileUpdate" v-if="imgArray.length < routeImageNum">
            <span>+</span>
          </div>
        </el-space>
        <input type="file" accept=".jp2,.jpe,.jpeg,.jpg,.png"  @change="fileChanged" ref="file" multiple="multiple" style="display:none;">
      </el-form-item>
      <el-form-item label="选择话题：">
        <el-select v-model="topicId" placeholder="请选择" size="mini" style="width: 8em;">
          <el-option v-for="item in topicArray" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否置顶：">
        <el-select v-model="topState" placeholder="请选择" size="mini" style="width: 8em;">
          <el-option v-for="item in topStateArray" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="置顶时间：" v-if="topState == 1">
        <el-date-picker
            v-model="dateTime"
            type="datetimerange"
            :shortcuts="shortcuts"
            range-separator=" - "
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="YYYY-MM-DD HH:mm:ss"
        />
      </el-form-item>
      <el-form-item label="置顶列表：" v-if="topState == 1">
        <el-select v-model="topType" placeholder="请选择" size="mini" style="width: 8em;">
          <el-option v-for="item in topTypeArray" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="消息推送：" v-if="topState == 1">
        <el-select v-model="push" placeholder="请选择" size="mini" style="width: 8em;">
          <el-option v-for="item in pushArray" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" v-loading="loading">确定</el-button>
    </div>
  </div>

</template>

<script>
import {imgPostFormData, getFormData, postFormData} from "@/api/api"
import { addOrUpdateOfficial,getTopicList, updateZoneImgDel } from "@/api/url";
import { positiveIntReg, negativeDecimal } from "@/assets/shared/reg-constant";

export default {
  name: "TagManageDialog",
  props: {
    value: Object
  },
  data() {
    return {
      releaseForm: this.value.releaseForm,
      idx: this.value.ids,
      loading: false,

      dateTime: [this.value.releaseForm.topStartTime?this.value.releaseForm.topStartTime:'', this.value.releaseForm.topEndTime?this.value.releaseForm.topEndTime:''],

      // 话题
      topicArray: [
        {name: '不选择', id: 0}
      ],
      topicId: this.value.releaseForm.topicId ? this.value.releaseForm.topicId : 0,

      // 置顶
      topStateArray: [
        {label: '置顶', value: 1},
        {label: '不置顶', value: 0}
      ],
      topState: this.value.releaseForm.topState == 1 ? this.value.releaseForm.topState : 0,

      // 置顶列表
      topTypeArray: [
        {label: '全部', value: 0},
        {label: '最新', value: 1},
        {label: '热门', value: 2},
        {label: '推荐', value: 3}
      ],
      topType: this.value.releaseForm.topType ? this.value.releaseForm.topType : 0,

      // 消息推送
      pushArray: [
        {label: '推送', value: 1},
        {label: '不推送', value: 0}
      ],
      push: this.value.releaseForm.topPush ? this.value.releaseForm.topPush : 0,

      // files: null,
      // src: this.value.ids > -1?this.value.releaseForm.avatar:'',

      imgArray: this.value.releaseForm.zoneImgList?this.value.releaseForm.zoneImgList:[],
      routeImageNum: 9,
      delImgIdArray: [],

      shortcuts: [
        {
          text: '最近一周',
          value: () => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            return [start, end]
          },
        },
        {
          text: '最近一个月',
          value: () => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            return [start, end]
          },
        },
        {
          text: '最近三个月',
          value: () => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            return [start, end]
          },
        },
      ]

    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    //更改或添加
    fileUpdate() {
      this.$refs.file.click();
    },

    //选取图片
    fileChanged(e) {
      if(e.target.files[0]) {
        for(let item of e.target.files) {
          let windowURL = window.URL || window.webkitURL;
          let src = windowURL.createObjectURL(item);
          let obj = {'img': src, 'smallImg': src, 'files': item};
          this.imgArray.push(obj);
        }
      }
    },

    // //更改或添加
    // headImgUpdate() {
    //   this.$refs.headImg.click();
    // },
    //
    // //选取图片
    // headImgChanged(e) {
    //   if(e.target.files[0]) {
    //     this.files = e.target.files[0];
    //     var windowURL = window.URL || window.webkitURL;
    //     this.src = windowURL.createObjectURL(this.files);
    //   }
    // },

    // 删除图片
    // delImg(idx) {
    //   if(this.imgArray[idx].id >= 0) {
    //     this.delImgIdArray.push(this.imgArray[idx].id);
    //   }
    //   this.imgArray.splice(idx,1);
    // },

    delImg(imgId, zoneId, index) {
      if(imgId) {
        let _this = this;
        this.$confirm('确定要删除图片？', {type: 'warning'}).then(() => {
          let param = {};
          param['id'] = imgId;
          param['zoneId'] = zoneId;
          postFormData(updateZoneImgDel, param).then((data) => {
            let {code, msg} = data;
            if (code == 200) {
              _this.imgArray.splice(index, 1);
              _this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'success'
              })
            } else {
              _this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'warning'
              })
            }
          })
        }).catch(() => {
        })
      }else {
        this.imgArray.splice(index,1);
      }
    },


    summit() {
      if(!this.releaseForm.msg) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请填写内容',
          type: 'warning'
        });
        return false
      }
      if(this.topState == 1 && !this.dateTime[0]) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请选择置顶时间',
          type: 'warning'
        });
        return false
      }
      this.loading = true
      let _this = this
      let param = new FormData();
      if (this.idx > -1) {
        param.append('id', this.releaseForm.id);
      } else {
        param.append('id', 0);
      }
      if(this.releaseForm.topId) {
        param.append('topId', this.releaseForm.topId);
      }else {
        param.append('topId', 0);
      }
      param.append('msg', this.releaseForm.msg);
      param.append('topicId', this.topicId);
      param.append('topState', this.topState);
      if(this.topState == 1) {
        param.append('startTime', this.dateTime[0]);
        param.append('endTime', this.dateTime[1]);
        param.append('type', this.topType);
        param.append('push', this.push);
      } else {
        if(this.idx > -1 && this.releaseForm.topId) {
          param.append('startTime', this.releaseForm.topStartTime);
          param.append('endTime', this.releaseForm.topEndTime);
        }
        param.append('type', 0);
        param.append('push', 0);
      }
      for(let i = 0; i < this.imgArray.length; i++) {
        if(!this.imgArray[i].id) {
          param.append('file' + i, this.imgArray[i].files);
        }
      }
      // param.append('delImgIdArr', this.delImgIdArray.toString());
      imgPostFormData(addOrUpdateOfficial, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          _this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          _this.$emit('confirm')
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        _this.loading = false
      }).catch(()=>{
        _this.loading = false
      })
    },



    getTopicList() {
      getFormData(getTopicList).then((data) => {
        if(data.code == 200) {
          this.topicArray = this.topicArray.concat(data.data)
        }
      })
    }

  },
  mounted() {
    this.getTopicList()
  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  float: left;
}
.img-box {
  width: 80px;
  height: 80px;
  position: relative;
}
.delIcon {
  background-color: rgba(0,0,0,0.8);
  width: 20px;
  height: 20px;
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
</style>
